import { Blockchain } from "@rarible/api-client"
import { shape } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const shapeConfig: StaticEthereumBlockchainConfig = {
  name: "Shape",
  icon: "/images/blockchains/shape.svg",
  isEvm: true,
  testnet: false,
  isTestnet: false,
  feesVersion: "v3",
  unionApi: "https://api.rarible.org",
  basePath: "https://shape-api.rarible.org",
  chainId: shape.id,
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  blockchain: Blockchain.SHAPE,
  chainName: shape.name,
  exchange: {
    v2: "0x30fc6eed1d302F5f5C4a8aa58047d1a730b3Cc91",
    wrapper: "0xBFb17500344bA3475d46091F5c8f1e33B31ed909",
  },
  blockExplorers: [
    {
      url: "https://shapescan.xyz/",
      icon: "/images/scanner.svg",
      adress: "https://shapescan.xyz/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "shape-node",
  transferProxies: {
    nft: "0x57559104c0e4fbc578fF4251b63eA0903d7CAe32",
    erc721Lazy: "0x13b05523634ABb96E6017Da71b7698CAecDf50b2",
    erc20: "0x4217a346C8b48731641327b65bb6F6d3243d64e2",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("SHAPE:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "Ethereum",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("SHAPE:0x4200000000000000000000000000000000000006"),
    symbol: "WETH",
    name: "Wrapped Ethereum",
    decimals: 18,
  },
  addFundsLink: "https://rarible.com/shape/swap",
  hasStabilityProtocol: true,
  viem: shape,
}

export const getShapeConfig = (): StaticEthereumBlockchainConfig => shapeConfig
